import React from 'react';
import FAQ from './faq.js';
import FAQ_agrupado from "./faq_agrupado.js"


const Module8 = () => {
  return (

  <div className="py-5 text-center" >
      <div className="">
        <h3 className="text-center fw-bold text-white special-font" style={{ letterSpacing: "8px", lineHeight: "22.0px" }}>
          FAQ - DÚVIDAS INICIAIS
        </h3>
        
      </div>

{/* <FAQ /> */}
<FAQ />



      </div>
  );
};

export default Module8;
